import React from "react";

const BUSINESS_MAPS_URL = "https://maps.app.goo.gl/VkJfjE2vE5vdioUS6";

// Real customer reviews provided by IBIALCON (Feb 2026).
// Kept here because the Google Business Profile is not yet indexed
// in the Places API — when it is, we can move back to a live fetch.
const REVIEWS = [
  {
    author: "Jessica García",
    rating: 5,
    text:
      "Fantástico !! Un viaje increíble ! Tenía cargador para el móvil, pone la música que te apetezca y tiene servicio de agua ! El conductor António Vargas un amor de conductor, nos trató genial ! Si vuelvo a Ibiza sin duda lo volveré a llamar !! Un 10 !",
  },
  {
    author: "Ruben Jesus Moreno Gomez",
    rating: 5,
    text:
      "El mejor servicio de transportes de Ibiza, conductores súper enrollados, ofrecen agua y te ambientan el viaje con la música que quieras! Súper recomendable. Toni fue nuestro chofer y nos ofreció todo tipo de servicios y nos resolvió todo tipo de preguntas!",
  },
  {
    author: "Elena Matilla",
    rating: 5,
    text:
      "Fuimos 6 amigas de despedida a Ibiza y los chicos de IBIROAD nos ayudaron un montón con recomendaciones y estuvieron súper pendientes de todo lo que nos hizo falta. La furgo es una pasada, pudimos cargar el móvil en todos los viajes.",
  },
  {
    author: "Sandra Torres Torres",
    rating: 5,
    text:
      "Servicio, trato y puntualidad de 10. Las recomendaciones que nos dieron, muy acertadas! Empresa muy recomendable, te lo hacen muy fácil todo!!",
  },
  {
    author: "Jose Juan Ros",
    rating: 5,
    text:
      "Servicio espectacular, una estrella más le pondría, comodidad, puntualidad y un trato inmejorable, totalmente recomendable.",
  },
];

const RATING_AVG = 5.0;
const RATING_TOTAL = REVIEWS.length;

function Stars({ value = 5, size = "sm" }) {
  const full = Math.round(value);
  const cls = size === "lg" ? "w-5 h-5" : "w-4 h-4";
  return (
    <div className="flex gap-0.5" aria-label={`${value} out of 5 stars`}>
      {[0, 1, 2, 3, 4].map((i) => (
        <svg
          key={i}
          className={`${cls} ${i < full ? "text-[#FFC857]" : "text-white/20"}`}
          viewBox="0 0 24 24"
          fill="currentColor"
        >
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77 5.82 21l1.18-6.88-5-4.87 6.91-1.01L12 2z" />
        </svg>
      ))}
    </div>
  );
}

const GoogleG = () => (
  <svg viewBox="0 0 48 48" className="w-5 h-5" aria-hidden>
    <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
    <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
    <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
    <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
    <path fill="none" d="M0 0h48v48H0z" />
  </svg>
);

export default function Reviews({ lang = "es" }) {
  const labels =
    lang === "es"
      ? {
          overline: "Opiniones · Google Maps",
          title: "Lo que dicen nuestros clientes",
          viewAll: "Ver todas las reseñas en Google",
          ratingsLabel: "reseñas verificadas",
        }
      : {
          overline: "Reviews · Google Maps",
          title: "What our customers say",
          viewAll: "See all reviews on Google",
          ratingsLabel: "verified reviews",
        };

  return (
    <section
      id="reviews"
      data-testid="reviews-section"
      className="relative py-24 md:py-32 bg-[#070B19] border-t border-[#C9A961]/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div
          className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14"
          data-reveal
        >
          <div>
            <div className="flex items-center gap-3 text-xs uppercase tracking-[0.3em] text-[#C9A961] mb-4">
              <GoogleG />
              <span>{labels.overline}</span>
            </div>
            <h2 className="font-[Playfair_Display] text-4xl md:text-6xl leading-tight">
              {labels.title}
            </h2>
            <div className="mt-4 flex items-center gap-4">
              <span className="font-[Playfair_Display] text-5xl text-[#C9A961] leading-none">
                {RATING_AVG.toFixed(1)}
              </span>
              <div>
                <Stars value={RATING_AVG} size="lg" />
                <p className="text-[11px] uppercase tracking-[0.25em] text-white/50 mt-1">
                  {RATING_TOTAL} {labels.ratingsLabel}
                </p>
              </div>
            </div>
          </div>

          <a
            href={BUSINESS_MAPS_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="reviews-google-link"
            className="inline-flex items-center gap-2 border border-[#C9A961]/40 px-5 py-3 text-[11px] uppercase tracking-[0.2em] text-[#C9A961] hover:bg-[#C9A961]/10 transition-colors"
          >
            <GoogleG />
            {labels.viewAll}
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {REVIEWS.map((r, i) => (
            <article
              key={i}
              data-testid={`review-card-${i}`}
              data-reveal
              className="bg-[#0D1424] border border-[#C9A961]/15 p-6 flex flex-col"
              style={{ transitionDelay: `${i * 60}ms` }}
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-[#C9A961]/20 text-[#C9A961] font-[Playfair_Display] flex items-center justify-center">
                  {r.author?.[0]?.toUpperCase() || "?"}
                </div>
                <div className="min-w-0">
                  <p className="font-[Playfair_Display] text-base text-white truncate">
                    {r.author}
                  </p>
                  <p className="text-[10px] uppercase tracking-[0.2em] text-white/40">
                    Google Maps
                  </p>
                </div>
                <div className="ml-auto">
                  <Stars value={r.rating} />
                </div>
              </div>
              <p className="text-sm text-white/75 leading-relaxed">{r.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
